import { createUrl } from "@/redux/api";
import {
  ChapterResponse,
  ChapterQueryParams,
  ChapterTags,
  TagType,
} from "@/redux/chapters/types";
import { isPaginatedResponse } from "@/redux/typeGuards";
import { BuilderType, PaginatedResponse } from "@/redux/types";

const chaptersService = (builder: BuilderType<ChapterTags>) => ({
  getChapters: builder.query<
    ChapterResponse[] | PaginatedResponse<ChapterResponse>,
    ChapterQueryParams
  >({
    query: (queryParams) => ({
      url: createUrl("/chapters/", queryParams),
      method: "GET",
    }),
    providesTags: (result): TagType[] =>
      result
        ? [
            ...(
              (isPaginatedResponse(result)
                ? result.results
                : result) as ChapterResponse[]
            ).map(
              (i): TagType => ({
                type: "Chapter",
                id: i.id,
              }),
            ),
            { type: "Chapters" },
          ]
        : [],
  }),
});

export default chaptersService;
